import { Configuration } from '../../../Domain/DTOs/Configuration/ConfigurationDTO';
import { CoreConfig } from './../../../CoreConfig';
import { createTextView } from './AnimatedTextView';
export const H4View = createTextView({
    provider: CoreConfig.provider,
    moduleName: CoreConfig.moduleName,
    componentName: Configuration.ComponentNames.h4,
    style: (theme, mediaQuery, window, props) => {
        var _a, _b, _c;
        return {
            container: Object.assign({ fontSize: 18, lineHeight: 24, marginBottom: 15, color: ((_a = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _a === void 0 ? void 0 : _a.text_color) || '#293b51', fontFamily: ((_b = theme.fonts) === null || _b === void 0 ? void 0 : _b.bold) || ((_c = theme.fonts) === null || _c === void 0 ? void 0 : _c.primary), fontWeight: 'bold' }, mediaQuery.lg({
                fontSize: 20,
                lineHeight: 26
            }))
        };
    }
});
